module.exports = __webpack_public_path__ + "static/fun-time/games/page002_game0/audio//0_Dusty.mp3";